/**
 * ADR-029 (Workforce Composition Reporting) — Phase 2 API client.
 * All filter params are serialised through buildEmployeeQueryParams (the
 * shared anti-drift contract, ADR-029 D9); groupBy/flatten are the
 * aggregation-only extras.
 */
import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';
import { buildEmployeeQueryParams } from './employeeQueryParams';

export const workforceCompositionApi = {
  /**
   * @param {Object} filterState - shared employee filter state
   * @param {Object} opts - { groupBy: string[]|string, flatten?: boolean }
   */
  getWorkforceComposition: async (filterState = {}, opts = {}) => {
    try {
      const params = buildEmployeeQueryParams(filterState);
      const groupBy = Array.isArray(opts.groupBy)
        ? opts.groupBy.join(',')
        : (opts.groupBy || '');
      if (groupBy) params.append('groupBy', groupBy);
      if (opts.flatten === true) params.append('flatten', 'true');
      return await authenticatedApi.get(
        `${API_BASE_URL}/reports/workforce-composition?${params.toString()}`
      );
    } catch (error) {
      if (error instanceof ApiError) throw error;
      throw new ApiError('Failed to load workforce composition report', error.status || 500);
    }
  }
};

export default workforceCompositionApi;
